// extracted by mini-css-extract-plugin
module.exports = {"info_list":"CoinSection_info_list__OA4WB","info_list_title":"CoinSection_info_list_title__k4d4G"};